import React, { useState } from 'react'
import { ModalWrapper, StyledButton, TextFields } from '../../../../../../components'
import { useDispatch, useSelector } from 'react-redux'
import { useGlobal } from '../../../../../../shared'
import { baseURL, urls } from '../../../../../../shared/config'
import {
  Box,
  Checkbox,
  Select,
  Input,
  MenuItem,
  ListItemText,
  Chip,
  Typography,
} from '@mui/material'
import { Delete } from '@mui/icons-material'
import axios from 'axios'
import { setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import { toast } from 'react-toastify'
import { highestInt } from '../../../../../../shared/utils/constants'

const UpdateClass = ({ open, handleClose,refetch }) => {
  const SchoolDInfo = useSelector((state) => state.global.SchoolDInfo)
  const [tuitionFee, setTuitionFee] = useState(SchoolDInfo?.tuition_fee || '')
  const [examFee, setExamFee] = useState(SchoolDInfo?.exam_fee || '')
  const dispatch = useDispatch()
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find(
    (school) => school.school_id == SchoolDInfo?.school_id,
  )?.school_name
  const { data: sectionList } = useGlobal({ userUrl: urls.ALL_SECTION })
  const [selectedSections, setSelectedSections] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)

  const [eistingSectionLists, setEistingSectionLists] = useState(SchoolDInfo?.grade_sections)
  const filteredSectionsInitialValue = sectionList?.filter(
    (option) => !eistingSectionLists?.some((item) => item.section_id === option.section_id),
  )

  const [filteredSections, setFilteredSections] = useState(filteredSectionsInitialValue)

  // console.log('---filteredSections',filteredSections);
  
  React.useEffect(() => {
    setFilteredSections(filteredSectionsInitialValue)
  }, [filteredSections, filteredSectionsInitialValue])

  const handlePopperOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopperClose = () => {
    setAnchorEl(null)
  }

  const MenuProps = {
    anchorEl,
    open: Boolean(anchorEl),
    onClose: handlePopperClose,
    anchorOrigin: {
      vertical: 'left',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
  }
  const handleDeleteSection = (sectionMapId) => {
    dispatch(setLoader(true))
    const apiSchool = `${urls.SECTION_DELETE}${sectionMapId}`
    axios
      .delete(`${baseURL}${apiSchool}`)
      .then(() => {
        const updatedEistingSectionLists = eistingSectionLists.filter(
          (item) => item.section_map_id !== sectionMapId,
        )

        // Find the deleted section from eistingSectionLists
        const deletedSection = eistingSectionLists.find(
          (item) => item.section_map_id === sectionMapId,
        )

        // Add the deleted section to filteredSections if it exists
        const updatedFilteredSections = deletedSection
          ? [...filteredSections, deletedSection]
          : filteredSections
        dispatch(setRefreshPage(true))
        toast.success(`Section Deleted Successfully!`)
        dispatch(setLoader(false))
        setEistingSectionLists(updatedEistingSectionLists)
        setFilteredSections(updatedFilteredSections)
      })
      .catch((error) => {
        console.error('Error deleting section:', error)
        toast.error(`Error deleting Section!`)
        dispatch(setLoader(false))
      })
  }

  const handleSubmit = () => {
    const gradeMapId = SchoolDInfo?.grade_map_id
    // const sectionsIds = selectedSections.join(',')

    const requestBody = {
      fee_id: SchoolDInfo?.fee_id,
      tuition_fee: tuitionFee,
      exam_fee: examFee,
    }
    const sectionUpdateUrl = `${baseURL}${urls.UPDATE_GRADE}${gradeMapId}&section_id=${`[${selectedSections}]`}`
    const feeUpdateUrl = `${baseURL}${urls.UPDATE_GRADE_FEES}`
    dispatch(setLoader(true))
    axios
      .patch(sectionUpdateUrl)
      .then(() => {
        // Second PATCH: update fees
        return axios.patch(feeUpdateUrl, requestBody)
      })
      .then(() => {
        dispatch(setRefreshPage(true))
        toast.success('Class Updated Successfully!')
        handleClose()
      })
      .catch((error) => {
        console.error('Error updating class:', error)
        toast.error('Error updating class!')
      })
      .finally(() => {
        dispatch(setLoader(false))
      })
  }

  return (
    <ModalWrapper open={open} handleClose={handleClose} width={'500px'} title={'Update Class'}>
      <div>
        <div className="text-fields">
          <TextFields label={'School'} value={userSchoolName} readOnly width={'100%'} />
          <TextFields label={'Grade'} value={SchoolDInfo?.grade} readOnly width={'100%'} />
        </div>

        <div className="text-fields">
          <TextFields
            label="Tuition Fee"
            value={tuitionFee}
            onChange={(e) => setTuitionFee(e.target.value)}
            width="100%"
          />
          <TextFields
            label="Exam Fee"
            value={examFee}
            onChange={(e) => setExamFee(e.target.value)}
            width="100%"
          />
        </div>
        <Box mb={3}>
          <Typography mb={2} className="custom-selectfield-label">
            Sections<span className="req">*</span>
          </Typography>
          <Select
            multiple
            value={selectedSections}
            onChange={(e) => setSelectedSections(e.target.value)}
            input={<Input />}
            variant="outlined"
            sx={{ width: '100%' }}
            renderValue={(selected) => (
              <div style={{ display: 'flex', gap: '5px' }}>
                {selected.length > 0 ? (
                  selected.map((value) => {
                    const section = sectionList.find((option) => option.section_id === value)
                    return <Chip key={value} label={section ? section.section : ''} />
                  })
                ) : (
                  <Typography className="">Select</Typography>
                )}
              </div>
            )}
            MenuProps={MenuProps}
            onOpen={handlePopperOpen}
            onClose={handlePopperClose}
            displayEmpty
          >
            {filteredSections?.map((option) => (
              <MenuItem key={option.section_id} value={option.section_id}>
                <Checkbox checked={selectedSections.indexOf(option.section_id) > -1} />
                <ListItemText primary={option.section} />
              </MenuItem>
            ))}
          </Select>
        </Box>

        <div
          className="grade-section-list"
          style={{ maxHeight: 150, overflowY: 'auto', marginBottom: '16px' }}
        >
          {eistingSectionLists?.map((item, index) => (
            <div
              key={index}
              style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
            >
              <Typography className="grade-chip">{item.section}</Typography>
              <Delete onClick={() => handleDeleteSection(item.section_map_id)} />
            </div>
          ))}
        </div>
      </div>

      <StyledButton onClick={handleSubmit}>Submit</StyledButton>
    </ModalWrapper>
  )
}

export default UpdateClass
